import { render, staticRenderFns } from "./RichVideoMessage.vue?vue&type=template&id=238bbcac&scoped=true&"
import script from "./RichVideoMessage.vue?vue&type=script&lang=js&"
export * from "./RichVideoMessage.vue?vue&type=script&lang=js&"
import style0 from "./RichVideoMessage.vue?vue&type=style&index=0&id=238bbcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238bbcac",
  null
  
)

export default component.exports